import React, { Component } from 'react'
import { connect } from 'react-redux'

import Comments from 'components/Comments'
import Attachments from 'components/Attachments'

import { attachmentPath } from 'selectors/attachments'
import { currentUser } from 'selectors/common'

let select = (state, props) => ({
	path: attachmentPath(state, props.transactionID)
})

export class RightSide extends Component{
	render(){
		let oneColomn = this.props.colspan == 1
		return(
			<div className="rightSide"
				style={{
					width: (this.props.colspan>1)?"50%":"100%"
				  , clear:"both"
					, paddingLeft:"5px"
				  , position: "relative"
				  , display: "block"
				  , overflowY: "hidden"
				  , paddingBottom: "50px"
				}}
			>
				<div className="wrapper"
					style={{
						paddingBottom: "70px"
					  , overflow:"hidden"
					  , minHeight: !oneColomn?"calc(100vh - 64px)":"0"
					  , borderLeft: !oneColomn? "1px solid rgba(0,0,0,0.3)" : "none"
					}}
				>
					<Attachments objectID={this.props.transactionID} path={this.props.path} removable={true} top={this.props.colspan == 2}/>
					<Comments objectID={this.props.transactionID} path={this.props.path} />
				</div>


			</div>
		)
	}
}

export default connect(select)(RightSide)



// WEBPACK FOOTER //
// ./src/routes/landlord/transactionForm/InvoiceForm/RightSide.js